<template>
  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 7.98096H19.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    <path d="M13.7129 1.98096L19.7319 8L13.7129 14.019" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
